import { create } from 'zustand'
import type { Script } from '@/features/script/domain/models/script.ts'

export const scriptSelector =
  (id: string) =>
  (state: ScriptStore): Script | undefined =>
    state.scripts.find((script) => script.id === id)

interface ScriptStore {
  // todo: change to Record<string, Script> for easier selection? (but uglier list rendering)
  scripts: Script[]
  storeScript: (script: Script) => void
  updateScript: (script: Script) => void
  deleteScript: (scriptId: string) => void
}

export const useScriptStore = create<ScriptStore>((set) => ({
  scripts: [],
  storeScript: (script: Script) => {
    set(({ scripts }) => ({ scripts: [...scripts, script] }))
  },
  updateScript: (script: Script) => {
    set(({ scripts }) => ({
      scripts: scripts.map((s) => (s.id === script.id ? script : s)),
    }))
  },
  deleteScript: (scriptId: string) => {
    set(({ scripts }) => ({
      scripts: scripts.filter((s) => s.id !== scriptId),
    }))
  },
}))
